// import { createSelector } from 'reselect';

export const getEmail = state => state.getIn(['forgotPassword', 'email']);